import { AxiosError, AxiosRequestConfig } from "axios";
import axios from "api";
import instance from "api";

const fileExt = ["pdf,", "doc", "docx", "csv"];
function hasExtension(filename: string) {
  const dotPosition = filename?.lastIndexOf(".");

  return dotPosition > 0 && dotPosition !== filename?.length - 1;
}
export function downloadUploadedFile(file: File | any) {
  const blob = new Blob([file], { type: file.type }); //fileType ?? file.type
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;

  // link.style.display = "none"; // NOTE: Do we need this?

  let fileExtention = "";
  if (file.type === "application/pdf") fileExtention = ".pdf";
  else if (
    file.type ===
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  )
    fileExtention = ".docx";
  else if (file.type === "application/msword") fileExtention = ".doc";
  else if (file.type === "text/csv") fileExtention = ".csv";

  link.setAttribute("download", `${file.name}${fileExtention ?? ""}`);

  if (typeof link.download === "undefined") {
    //safari workaround
    link.setAttribute("target", "_blank");
  }

  document.body.appendChild(link);
  link.click();

  setTimeout(function() {
    document.body.removeChild(link);
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  }, 100);
}

export const getFileFromURL = async (
  url: string,
  fileName: string, //better without extension set in FE - use response.data.type (BE) for extension
  fetchConfig?: AxiosRequestConfig,
  getOrPost?: "get" | "post" | undefined,
  responseType: "arraybuffer" | "blob" = "blob" // "arraybuffer" for zip files
): Promise<File | AxiosError> => {
  const config: AxiosRequestConfig = {
    ...fetchConfig,
    responseType: responseType,
  };
  try {
    if (getOrPost === "post") {
      const params = config.params;
      const parsedConfig = { ...config, params: undefined };

      const response = await instance.post(url, params, parsedConfig);

      const file = new File([response.data], fileName, {
        type: response.headers["content-type"],
        // type: response.data.type,
      });

      return file;
    } else {
      const response = await instance.get<Blob>(url, config);

      const file = new File([response.data], fileName, {
        type: response.data.type,
      });

      return file;
    }
  } catch (exception) {
    const axiosError = exception as AxiosError;
    if (axiosError.response?.status !== 200) {
      return axiosError;
    }

    //some other error
    throw axiosError;
  }
};
